import React from 'react';
import styled, { css } from 'styled-components';

type MoneyFeeDisplayProps = {
  moneyName: string | undefined;
  paymentFeeRate: string;
  systemFee: string;
  fixedFee: string;
};

const MoneyFeeBlock = styled.div`
  ${({ theme: { spacing, colors, borderRadius } }) => css`
    border: 1px solid ${colors.gray['100']};
    border-radius: ${borderRadius['4']};
    padding: ${spacing['12']} ${spacing['8']};
    width: 440px;
    flex-shrink: 0;
  `}
`;

const MoneyFeeTitle = styled.h3`
  ${({
    theme: {
      spacing,
      typography: { body2 },
    },
  }) => css`
    font-size: ${body2.bold.fontSize};
    font-weight: ${body2.bold.fontWeight};
    line-height: ${body2.bold.lineHeight};
    margin-bottom: ${spacing['12']};
  `}
`;

const MoneyFeeRow = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    gap: ${spacing['16']};
    margin-bottom: ${spacing['8']};
  `}
`;

const MoneyFeeItem = styled.div`
  ${({ theme: { spacing } }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${spacing['4']};
  `}
`;

const MoneyFeeLabel = styled.div`
  ${({
    theme: {
      typography: { body2 },
      colors,
    },
  }) => css`
    font-size: ${body2.regular.fontSize};
    line-height: ${body2.regular.lineHeight};
    color: ${colors.gray['300']};
    text-align: left;
  `}
`;

const MoneyFeeValue = styled.div`
  ${({
    theme: {
      typography: { body2 },
      colors,
    },
  }) => css`
    font-size: ${body2.regular.fontSize};
    line-height: ${body2.regular.lineHeight};
    color: ${colors.gray['400']};
    text-align: left;
  `}
`;

const MoneyFeeDisplay = ({
  moneyName,
  paymentFeeRate,
  systemFee,
  fixedFee,
}: MoneyFeeDisplayProps) => {
  return (
    <MoneyFeeBlock>
      <MoneyFeeTitle>{moneyName}</MoneyFeeTitle>
      <MoneyFeeRow>
        <MoneyFeeItem>
          <MoneyFeeLabel>決済手数料(％)</MoneyFeeLabel>
          <MoneyFeeValue>{paymentFeeRate}</MoneyFeeValue>
        </MoneyFeeItem>
        <MoneyFeeItem>
          <MoneyFeeLabel>月額システム利用料</MoneyFeeLabel>
          <MoneyFeeValue>{systemFee}</MoneyFeeValue>
        </MoneyFeeItem>
        <MoneyFeeItem>
          <MoneyFeeLabel>その他固定費</MoneyFeeLabel>
          <MoneyFeeValue>{fixedFee}</MoneyFeeValue>
        </MoneyFeeItem>
      </MoneyFeeRow>
    </MoneyFeeBlock>
  );
};

export default MoneyFeeDisplay;
